module.exports = __webpack_public_path__ + "static/calpoly.2b241ec9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/calpoly.png
// module id = 2179
// module chunks = 61762850755587